// 依頼詳細ステータス検索条件
export class ReceptionDetailStatusSearchCondition {
  isExpired: boolean;
  isTemporary: boolean;
  isBacked: boolean;

  getSummary(): string {
    return (this.isExpired ? "期限切れ，" : "") +
      (this.isTemporary ? "一時保存，" : "") +
      (this.isBacked ? "差戻し　" : "");
  }

  clone(): ReceptionDetailStatusSearchCondition {
    const newObj = new ReceptionDetailStatusSearchCondition();
    newObj.isExpired = this.isExpired;
    newObj.isTemporary = this.isTemporary;
    newObj.isBacked = this.isBacked;

    return newObj;
  }
}
